import { createRouter, createWebHistory } from 'vue-router'
import { useSessionStore } from '@/stores/session'
import { usePlatformStore } from '@/stores/platform'
import { usePortalStore } from '@/stores/portal'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', name: 'landing', component: () => import('@/views/LandingView.vue'), meta: { public: true } },
    { path: '/staff', name: 'login', component: () => import('@/views/LoginView.vue'), meta: { public: true } },
    { path: '/login', redirect: { name: 'login' } },
    { path: '/root/login', name: 'root-login', component: () => import('@/views/RootLoginView.vue'), meta: { platform: true, public: true } },
    { path: '/root', name: 'root', component: () => import('@/views/RootDashboardView.vue'), meta: { platform: true } },
    { path: '/visitor/login', name: 'visitor-login', component: () => import('@/views/VisitorLoginView.vue'), meta: { visitor: true, public: true } },
    { path: '/visitor', name: 'visitor', component: () => import('@/views/VisitorDashboardView.vue'), meta: { visitor: true } },
    {
      path: '/staff/workspace', component: () => import('@/layouts/AppShell.vue'),
      children: [
        { path: '', name: 'overview', component: () => import('@/views/OverviewView.vue') },
        { path: 'clients', name: 'clients', component: () => import('@/views/ClientsView.vue') },
        { path: 'memberships', name: 'memberships', component: () => import('@/views/MembershipsView.vue') },
        { path: 'schedule', name: 'schedule', component: () => import('@/views/ScheduleView.vue') },
        { path: 'attendance', name: 'attendance', component: () => import('@/views/AttendanceView.vue') },
        { path: 'settings', name: 'settings', component: () => import('@/views/SettingsView.vue') },
      ],
    },
    { path: '/clients', redirect: { name: 'clients' } },
    { path: '/memberships', redirect: { name: 'memberships' } },
    { path: '/schedule', redirect: { name: 'schedule' } },
    { path: '/attendance', redirect: { name: 'attendance' } },
    { path: '/settings', redirect: { name: 'settings' } },
  ],
})

router.beforeEach(async (to) => {
  if (to.meta.platform) {
    const platform = usePlatformStore()
    const authenticated = await platform.bootstrap()
    if (to.name !== 'root-login' && !authenticated) return { name: 'root-login' }
    if (to.name === 'root-login' && authenticated) return { name: 'root' }
    return true
  }
  if (to.meta.visitor) {
    const portal = usePortalStore()
    const authenticated = await portal.bootstrap()
    if (to.name !== 'visitor-login' && !authenticated) return { name: 'visitor-login' }
    if (to.name === 'visitor-login' && authenticated) return { name: 'visitor' }
    return true
  }
  const store = useSessionStore()
  await store.bootstrap()
  if (!to.meta.public && !store.isAuthenticated) return { name: 'login', query: { next: to.fullPath } }
  if (to.name === 'login' && store.isAuthenticated) return { name: 'overview' }
  return true
})

export default router
